module.exports = __webpack_public_path__ + "static/media/outbuilding.a157aa82.png";